import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { HeartHandshake } from 'lucide-react';
export function EmotionalValidation() {
  return <Section background="light-pink" containerSize="md" className="text-center" data-id="element-57">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="bg-white/60 backdrop-blur-sm p-8 md:p-12 rounded-3xl border border-rose-100 shadow-lg" data-id="element-58">
        <div className="flex justify-center mb-6" data-id="element-59">
          <div className="bg-rose-100 p-4 rounded-full" data-id="element-60">
            <HeartHandshake className="w-10 h-10 text-rose-500" data-id="element-61" />
          </div>
        </div>

        <h3 className="text-2xl md:text-3xl font-black text-slate-900 mb-6 leading-tight" data-id="element-62">
          No estás rota. Estás agotada de sostener demasiado con muy poca
          energía.
        </h3>

        <p className="text-xl text-slate-700 leading-relaxed" data-id="element-63">
          El cansancio que sentís no es flojera ni desmotivación. Es desgaste
          real de trabajar, estudiar, cumplir y seguir… incluso cuando la
          batería ya está en rojo.
        </p>
      </motion.div>
    </Section>;
}